const AccountPageBase = '/application/user/account';
const ViewTemplatesBase = '/application/user/view-templates';
const AssetManagerBase = '/application/user/asset-manager';
const IntegrationBase = '/application/user/integration';
const EbayListingBase = '/application/user/ebay-listing';
const ProductBase = '/application/user/product';
const exported = {
  MyAccount: {
    Layout: '/application/user',
    Integration: IntegrationBase,
    IntegrationIframeHidden: IntegrationBase + '-iframe-hidden',
    IntegrationUpgrade: IntegrationBase + '-upgrade',
    ViewDesigns: '/application/user/view-designs',
    ViewTemplatesBase,
    ViewTemplates: ViewTemplatesBase + '(/:folderName)',
    Listings: '/application/user/listings',
    Upgrade: '/application/user/upgrade',
    AssetManagerBase,
    AssetManager: `${AssetManagerBase}(/:folderName)`,
    RedirectToPayPal: '/application/user/test-paypal-one',
    AccountPageBase,
    AccountPage: AccountPageBase + '(/:section)',
    ClearDescription: '/application/user/clear-description',
    EbayListingDataFetcher: EbayListingBase,
    EbayListing: EbayListingBase + '/edit',
    Inventory: '/application/user/catalog',
    Dashboard: '/application/user/dashboard',
    InventoryManagement: '/application/user/inventory',
    Attributes: '/application/user/attributes',
    FindEbayProduct: EbayListingBase + '/find-product',
    PublishToEbay: '/application/user/publish-to-ebay',
    PublishToAmazon: '/application/user/publish-to-amazon',
    Import: '/application/user/import',
    EbayListings: '/application/user/ebay-listings',
    AmazonListings: '/application/user/amazon-listings',
    ProductBase,
    Product: `${ProductBase}(/:id)`,
  },
  Auth: {
    Layout: '/application/index',
    Logout: '/application/index/logout',
  },

  Editor: {
    TemplateURL: '/lister',
  },
};

export default exported;

export const {MyAccount, Auth, Editor} = exported;
